<template>
  <!-- "Learn" column of a Launchpad section: main video + compact secondary videos -->
  <div class="flex flex-col gap-3.5 p-5 bg-neutral-10">
    <SetupVideoSlot
      v-if="hasMainVideo"
      :video="learn.video"
      :section="sectionId"
      :location="`section:${sectionId}`"
    />

    <div
      v-if="secondaryVideos.length"
      class="flex flex-col gap-1"
    >
      <SetupVideoSlot
        v-for="video in secondaryVideos"
        :key="video.youtubeId || video.mediaId"
        :video="video"
        compact
        :section="sectionId"
        :location="`section:${sectionId}:secondary`"
      />
    </div>
  </div>
</template>

<script>
import SetupVideoSlot from './SetupVideoSlot.vue'
import { hasVideoMedia } from '@/utils/setup/setupVideo'

export default {
  name: 'SetupLearnPanel',
  components: { SetupVideoSlot },
  props: {
    // { video, secondaryVideos? } from setupContent
    learn: {
      type: Object,
      required: true
    },
    sectionId: {
      type: String,
      required: true
    }
  },
  computed: {
    hasMainVideo () {
      return hasVideoMedia(this.learn.video)
    },
    secondaryVideos () {
      return (this.learn.secondaryVideos || []).filter(hasVideoMedia)
    }
  }
}
</script>
